"use strict";

export class Floating {
    constructor() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        const startElem = document.getElementById('start');
        const endElem = document.getElementById('end');
        const floatingElem = document.querySelector('.l-floating');

        if (!startElem || !floatingElem) {
            return;
        }


        const handleScroll = () => {
            const scrollHeight = document.documentElement.scrollHeight;
            const clientHeight = window.innerHeight;
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            const scrollPosition = clientHeight + currentScroll;

            // 各位置の取得
            const startPosition = startElem.getBoundingClientRect().top + currentScroll;
            const endPosition = endElem ? (endElem.getBoundingClientRect().top + currentScroll) : scrollHeight;

            // 判定ロジック
            if (startPosition <= currentScroll) {
                if (endPosition <= scrollPosition) {
                    floatingElem.classList.remove('fixed');
                } else {
                    floatingElem.classList.add('fixed');
                }
            } else {
                floatingElem.classList.remove('fixed');
            }
        };

        window.addEventListener('load', handleScroll);
        window.addEventListener('scroll', handleScroll, { passive: true });
    }
}